export default __webpack_public_path__ + "static/media/bitcoin.6fb91b13.svg";